function asyncRetry<T>(fn: () => Promise<T>, ms: number): Promise<T> {
  return new Promise((resolve) => {
    fn()
      .then(resolve)
      .catch(() => {
        setTimeout(() => {
          asyncRetry(fn, ms).then(resolve);
        }, ms);
      });
  });
}

export default asyncRetry;
